import { render, staticRenderFns } from "./ReportTech.vue?vue&type=template&id=1d4663de&"
import script from "./ReportTech.vue?vue&type=script&lang=js&"
export * from "./ReportTech.vue?vue&type=script&lang=js&"
import style0 from "./ReportTech.vue?vue&type=style&index=0&id=1d4663de&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports